import { Box, CardActions, Grid, Skeleton } from '@mui/material'
import { ImageCard, imageCardGridProps, imagePreviewSx } from './Image'

export default function ImageCardSkeleton() {
  return <Grid item {...imageCardGridProps}>
    <ImageCard
      elevation={0}
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.11)',
      }}
    >
      <Box
        component="div"
        sx={imagePreviewSx}
      />
      <CardActions
        sx={{
          pl: 2,
          flexGrow: 1,
          backgroundColor: '#fff',
        }}
      >
        <Box
          component="div"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            py: 1,
          }}
        >
          <Skeleton variant="text" height={24} width="75%" />
          <Skeleton variant="text" height={18} width="45%" />
          <Skeleton variant="text" height={18} width="60%" />
        </Box>
      </CardActions>
    </ImageCard>
  </Grid>
}
